import {
  MISTYPED_TOP_LEVEL_DOMAIN_MAP,
  MISTYPED_SECOND_LEVEL_DOMAIN_MAP,
} from './constants'

export const validateTopLevelDomain = value => {
  const mistypedTopLevelDomain = Object
    .entries(MISTYPED_TOP_LEVEL_DOMAIN_MAP)
    .reduce((_, [correctValue, mistypedValuesArr]) => {
      const mistypedValue = mistypedValuesArr.find(mistypedVal => value.endsWith(`.${mistypedVal}`))

      return mistypedValue ? {
        correctValue,
        mistypedValue,
      } : null
    }, null)

  return mistypedTopLevelDomain
}

export const validateSecondLevelDomain = value => {
  const mistypedSecondLevelDomain = Object
    .entries(MISTYPED_SECOND_LEVEL_DOMAIN_MAP)
    .reduce((_, [correctValue, mistypedValuesArr]) => {
      const mistypedValue = mistypedValuesArr.find(mistypedVal => value.includes(`@${mistypedVal}.`))

      return mistypedValue ? {
        correctValue,
        mistypedValue,
      } : null
    }, null)

  return mistypedSecondLevelDomain
}
